import React from "react";
import "./styles.scss";

const ServiceDelivery = () => (
    <section className="service-delivery">
        <div className="inner service-delivery__inner">
            <div className="service-delivery__content">
                <h1 className="service-delivery__title">
                    How we deliver our services
                </h1>
                <div className="service-delivery__points">
                    <div className="service-delivery__point">
                        <div className="service-delivery__point-text">
                            <h2 className="service-delivery__subtitle">
                                We research
                            </h2>
                            <p className="service-delivery__text">
                                We can offer research either as a continued
                                service or as part of ad-hoc requests such as
                                investment due diligence.
                            </p>
                        </div>
                    </div>
                    <div className="service-delivery__point">
                        <div className="service-delivery__point-text">
                            <h2 className="service-delivery__subtitle">
                                We act as a sub-advisor
                            </h2>
                            <p className="service-delivery__text">
                                Acting as the sub-advisor to your investment we
                                can provide research and risk management
                                services, as well as advise on asset allocation.
                                Your firm will have ownership and discretion
                                over allocation while we will advise.
                            </p>
                        </div>
                    </div>
                    <div className="service-delivery__point">
                        <div className="service-delivery__point-text">
                            <h2 className="service-delivery__subtitle">
                                We manage your portfolio
                            </h2>
                            <p className="service-delivery__text">
                                We can manage your investments under an agreed
                                mandate. Your firm will have ownership of the
                                investments while we will have discretion over
                                allocation.
                            </p>
                        </div>
                    </div>
                </div>
                <div className="service-delivery__cta">
                    <span className="service-delivery__cta-title">
                        Discover the best opportunities in direct lending with
                        Orca
                    </span>
                    <a
                        className="hero-full__cta no-underline"
                        href="https://app.hubspot.com/meetings/iain7"
                        title="Schedule a call now"
                        target="_blank"
                    >
                        <button className="btn-simple btn-lg btn-yellow btn-mobile">
                            Schedule a call now
                        </button>
                    </a>
                </div>
            </div>
        </div>
    </section>
);

export default ServiceDelivery;
